import { useParams } from 'react-router-dom';
import { OrderDetailsView } from '../../shared/Orders/OrderDetails/OrderDetailsView';
import { PageContainer } from '../../shared/Styled/Styled';

/** `/orders/:id`: one order in full, addressed by the id in the path. */
export const OrderDetailsPage = (): JSX.Element => {
  const { id } = useParams();

  return (
    <PageContainer>
      <OrderDetailsView orderId={Number(id)} />
    </PageContainer>
  );
};

export default OrderDetailsPage;
